import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { hasStakeholders } from "@/components/features/InsuredGoods/utils/stakeholders";
import { DetailPanel, DetailPanels } from "@/components/organisms";

import { panelDescriptionSchema, panelKeyDatesSchema, panelStakeholdersSchema } from "./panelSchema";

const AccordionIndex = {
    DESCRIPTION: "description",
    STAKEHOLDERS: "stakeholders",
    ADMINISTRATIVE: "administrative",
};

type VehicleTabPanelProps = {
    details: MyBrokerApi.Vehicle;
};

const VehicleTabPanel: FC<VehicleTabPanelProps> = ({ details }) => {
    const { t, i18n } = useTranslation();

    return (
        <DetailPanels defaultDetailPanelOpen={AccordionIndex.DESCRIPTION}>
            <DetailPanel
                dataTestId="insured_good_detail_vehicle_description"
                id={AccordionIndex.DESCRIPTION}
                title={t("Common.Description")}
                infoList={panelDescriptionSchema(details, i18n.language)}
            />
            {hasStakeholders(details) && (
                <DetailPanel
                    dataTestId="insured_good_detail_vehicle_stakeholders"
                    id={AccordionIndex.STAKEHOLDERS}
                    title={t("Common.Stakeholders")}
                    infoList={panelStakeholdersSchema(details)}
                />
            )}
            <DetailPanel
                dataTestId="insured_good_detail_vehicle_administrative_dates"
                id={AccordionIndex.ADMINISTRATIVE}
                title={t("InsuredGood.Details.Vehicle.AdministrativeDates")}
                infoList={panelKeyDatesSchema(details)}
            />
        </DetailPanels>
    );
};

export default VehicleTabPanel;
